import { render, staticRenderFns } from "./ModalInviteList.vue?vue&type=template&id=b7bf63b0&"
import script from "./ModalInviteList.vue?vue&type=script&lang=js&"
export * from "./ModalInviteList.vue?vue&type=script&lang=js&"
import style0 from "./ModalInviteList.vue?vue&type=style&index=0&id=b7bf63b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports